import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import {
  promoReportsRequest,
  promoReportsResponse,
  promoReportsCreateRequest,
  promoReportsCreateResponse,
  usersListRequest,
  usersListResponse,
  changeUserStatus,
  changeUserStatusResponse,
  changeOrgUserStatus,
  changeOrgUserStatusResponse,
  reportFormToggle,
} from './actions'

export const defaultState = {
  errors: null,
  promotedReports: null,
  promotedReport: null,
  promotedReportFormOpen: false,
  usersList: null
}

const promotedReportFormOpen = handleActions({
  [reportFormToggle]: (state, action) => {
    if (typeof action.payload === 'boolean') {
      return action.payload
    }
    return !state
  }
}, defaultState.promotedReportFormOpen)

const promotedReports = handleActions({
  [promoReportsRequest]: (state, action) => (undefined),
  [promoReportsResponse]: (state, action) => {
    if (action?.payload?.message?.includes('NetworkError')) {
      state = { blocked: action.payload }
    }
    return (action.error ? state : action.payload)
  }
}, defaultState.promotedReports)

const promotedReport = handleActions({
  [promoReportsCreateRequest]: () => (null),
  [promoReportsCreateResponse]: (state, action) => {
    return action.error ? state : null
  }
}, null)

const usersList = handleActions({
  [usersListRequest]: (state, action) => (null),
  [usersListResponse]: (state, action) => {
    if (action?.payload?.message?.includes('NetworkError')) {
      state = { blocked: action.payload }
    }
    return action.error ? state : action.payload
  },
}, null)

const userStatus = handleActions({
  [changeUserStatus]: (state, action) => (null),
  [changeUserStatusResponse]: (state, action) => {
    return action.error ? state : action.payload
  },
  [changeOrgUserStatus]: (state, action) => (null),
  [changeOrgUserStatusResponse]: (state, action) => {
    return action.error ? state : action.payload
  },
}, null)

export default combineReducers({
  promotedReports,
  promotedReport,
  promotedReportFormOpen,
  usersList,
  userStatus
})
